// Pure helpers for the Newsletter page (kept out of index.js so they can be unit-tested).

// What to say after POST /newsletter/send answers. It used to say "Newsletter Sent!" whatever
// the counts were; the server now errors when nothing went out, and this reads the real counts.
export function sendResultNotice(response) {
  const { total = 0, sent = 0, failed = 0 } = response?.stats || {};
  if (sent === 0) {
    return {
      color: "error",
      icon: "error",
      title: "Newsletter not sent",
      content: response?.message || `None of the ${total} emails went out.`,
    };
  }
  if (failed > 0) {
    return {
      color: "warning",
      icon: "warning",
      title: "Newsletter partly sent",
      content: `Sent to ${sent} of ${total} subscribers; ${failed} failed.`,
    };
  }
  return {
    color: "success",
    icon: "check",
    title: "Newsletter sent",
    content: response?.message || `Sent to all ${sent} subscribers.`,
  };
}

// Whether the composer holds anything worth asking about before it closes. An editor that was
// typed in and cleared still holds markup like <p><br></p>, which is not content.
export function hasDraft(subject, content) {
  if ((subject || "").trim()) return true;
  const html = content || "";
  if (/<(img|video|iframe|svg)\b/i.test(html)) return true;
  return (
    html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;| /g, " ")
      .trim() !== ""
  );
}

// What to say when the send request fails. The send is one long request: with no reply at all
// (browser or proxy timeout, dropped connection, a 502-504 from the proxy) the emails may still
// be going out, so this must not read as "not sent" — that invited a second send to everyone.
// The server refuses the same newsletter for a day, and answers its own failures with 500.
export function newsletterFailureNotice(err) {
  const status = err?.response?.status;
  if (!err?.response || [502, 503, 504].includes(status)) {
    return {
      color: "warning",
      icon: "warning",
      title: "The newsletter may still be sending",
      content:
        "No reply came back from the server, but the emails may still be going out. Don't send it again: " +
        "wait a few minutes, then check with a subscriber. Sending the same newsletter again is blocked for a day.",
    };
  }
  if (status === 409) {
    return {
      color: "info",
      icon: "info",
      title: "Not sent again",
      content: err.response.data?.error || "This newsletter was not sent again.",
    };
  }
  return {
    color: "error",
    icon: "error",
    title: "Newsletter not sent",
    content: err.response.data?.error || "Failed to send newsletter",
  };
}
